// extracted by mini-css-extract-plugin
module.exports = {"base":"Arrow_base__DkJWX","bounceAlpha":"Arrow_bounceAlpha__vIbXh","pointLeft":"Arrow_pointLeft__KLj53","bounceAlphaReverse":"Arrow_bounceAlphaReverse___OKWr"};